// extracted by mini-css-extract-plugin
export default {"categoryBucket":"CategoryBucket_categoryBucket__ppG2Z"};